import { useEffect, useMemo, useState } from 'react';
import calculateTimeLeft from 'utils/calculateTimeLeft';
import styles from './styles.module.css';

const CountdownNew = ({ targetDate, hasMoreText = false }) => {
  const [timeRemaining, setTimeRemaining] = useState(0);

  const memoizedTimeRemaining = useMemo(() => calculateTimeLeft(targetDate), [timeRemaining]);

  useEffect(() => {
    setTimeRemaining((data) => data + 1);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining((data) => data + 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [targetDate]);
  if (!targetDate) {
    return null;
  }
  return (
    <>
      {memoizedTimeRemaining?.seconds ? (
        <div>
          {memoizedTimeRemaining?.days > 0 ? (
            <span>
              {hasMoreText ? 'Còn' : ''} {memoizedTimeRemaining?.days} Ngày,{' '}
            </span>
          ) : (
            <span>Còn </span>
          )}
          <span className={styles.minWidth}>{memoizedTimeRemaining?.hours}</span>
          <span className={styles.minWidth}>{memoizedTimeRemaining?.minutes}</span>
          <span className={styles.minWidth}>{memoizedTimeRemaining?.seconds}</span>
        </div>
      ) : (
        <span>Khuyến mãi đã kết thúc</span>
      )}
    </>
  );
};

export default CountdownNew;
